import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Material from './Material';


interface MaterialTableProps {
  data: Material[];
  columns: TableColumn<Material>[];
  customStyles: Record<string, any>;
}

const MaterialTable: React.FC<MaterialTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Material>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default MaterialTable;